<template>
  <div id="articulos" v-on:keyup.esc="cerrarModal" tabindex="-1">
    <div id="blur">
      <form class="form-inline" style="margin:10px auto;">
        <div class="form-group" style="margin:0 auto;">
          <select
            v-model="selectBusqueda"
            class="form-control input-group-text"
            style="max-width:400px;min-width:200px"
          >
            <option v-for="(busq,index) in select" :key="index" :value="busq.valor">{{busq.nombre}}</option>
          </select>
          <div class="col" style="padding:0px;">
            <input
              type="text"
              class="form-control"
              id="busqueda"
              style="max-width:1000px;min-width:200px"
              required
            />
          </div>
          <button
            style="margin-left:5px; margin-top:0px"
            class="btn btn-info"
            type="submit"
            @click.prevent="realizarBusqueda"
          >
            <i class="fa fa-search" style="display: inline;"></i>
            {{$i18n.t('search')}}
          </button>
          <button class="btn btn-info" type="button" style="margin-left:5px">
            <i
              class="fa"
              :class="[showDesde ? 'fa-caret-up' : 'fa-caret-down']"
              @click.prevent="showDesde=!showDesde"
            ></i>
          </button>
          <button
            @click.prevent="limpiarFiltro"
            class="btn btn-info"
            style="margin-left:5px"
            :title="$i18n.t('cleanGrid')"
          >
            <i class="fa fa-eraser"></i>
          </button>
        </div>
      </form>
      <div v-if="showDesde" class="form-inline d-flex justify-content-center">
        <label>{{'Desde'}}:</label>
        <input type="date" class="form-control" v-model="desde" />

        <label>{{'Hasta'}}:</label>
        <input type="date" class="form-control" v-model="hasta" />
      </div>
      <dx-data-grid
        :data-source="dataSource"
        ref="grillaArticulo"
        :loadPanel="loadPanel"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :column-min-width="20"
        :show-borders="true"
        :remote-operations="remote"
        :allow-filter="true"
        :headerFilter="headerFilter"
        :repaint-changes-only="true"
        :filterRow="filterRow"
        :noDataText="$i18n.t('tabla.nodata')"
        :columnAutoWidth="true"
        :height="500"
        :columnFixing="columnFixing"
        :selection="selection"
        :stateStoring="storage"
        :columnChooser="columnChooser"
        :grouping="grouping"
        :sorting="sorting"
      >
        <dx-column
          :caption="this.$i18n.t('cpr.columns.cprId')"
          data-field="cprId"
          :allow-header-filtering="false"
        />
        <dx-column
          :width="100"
          :allow-sorting="false"
          :allow-filtering="false"
          data-field="bucket_id"
          :caption="this.$i18n.t('articulo.columns.preview')"
          cell-template="cellTemplate"
          alignment="left"
        />
        <dx-column :caption="this.$i18n.t('cpr.columns.tipo')" data-field="tipo" />
        <dx-column
          caption="Clasificación"
          :allow-header-filtering="false"
          data-field="clasificacion"
          :visible="false"
        />
        <dx-column
          :caption="this.$i18n.t('cpr.columns.tipo_pago')"
          data-field="tipoPago"
          :allow-header-filtering="false"
          :visible="false"
        />
        <dx-column
          :caption="this.$i18n.t('cpr.columns.ptoVta')"
          data-field="nro"
          :allow-header-filtering="false"
          :visible="false"
        />
        <dx-column :caption="this.$i18n.t('cpr.columns.nro')" data-field="nroCpr" />
        <dx-column :caption="this.$i18n.t('cpr.columns.letra')" data-field="letra" />
        <dx-column :caption="this.$i18n.t('cpr.columns.estado')" data-field="estado" />
        <dx-column :caption="this.$i18n.t('cpr.columns.monto')" data-field="monto" />
        <dx-column :caption="this.$i18n.t('cpr.columns.saldo')" data-field="saldo" />
        <dx-column :caption="this.$i18n.t('cpr.columns.cond_vta')" data-field="cond_vta" />
        <dx-column :caption="this.$i18n.t('cpr.columns.domicilio')" data-field="domicilio" />
        <dx-column :caption="this.$i18n.t('cpr.columns.localidad')" data-field="localidad" />
        <dx-column
          :caption="this.$i18n.t('cpr.columns.fecha_emision')"
          data-field="fecha_emision"
          data-type="date"
          format="dd/MM/yyyy"
        />
        <dx-column :caption="this.$i18n.t('cpr.columns.razon_social')" data-field="razon_social" />
        <dx-column :caption="this.$i18n.t('cpr.columns.cuit')" data-field="cuit" />
        <dx-column
          :caption="this.$i18n.t('articulo.columns.info')"
          type="buttons"
          cssClass="botonestd"
          :buttons="buttons"
        />
        <div style="height:80px" slot="cellTemplate" slot-scope="{ data }">
          <slider :id="data.value" />
        </div>
        <dx-paging :page-size="50" :visible="true" :page-index="0" />
        <dx-pager :show-page-size-selector="true" :visible="true" :show-info="true" />
      </dx-data-grid>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-console */
import {
  DxDataGrid,
  DxColumn,
  DxPager,
  DxPaging
} from "devextreme-vue/data-grid";
import $ from "jquery";
import CustomStore from "devextreme/data/custom_store";
//import modal from "../components/modal";
import slider from "../components/slider";
//import { DxButton } from "devextreme-vue";
import notify from "devextreme/ui/notify";

export default {
  name: "articulos",
  components: {
    DxDataGrid,
    //modal,
    slider,
    DxColumn,
    //    DxButton,
    DxPager,
    DxPaging
  },
  data() {
    return {
      dataSource: [],
      desde: undefined,
      hasta: undefined,
      headerFilter: {
        visible: true,
        texts: {
          cancel: this.$i18n.t("tabla.cancel"),
          emptyValue: this.$i18n.t("tabla.emptyValue"),
          ok: this.$i18n.t("tabla.ok")
        }
      },
      sorting: {
        ascendingText: this.$i18n.t("tabla.ord_asc"),
        clearText: this.$i18n.t("tabla.clearText"),
        descendingText: this.$i18n.t("tabla.descendingText")
      },
      columnChooser: {
        allowSearch: false,
        enabled: true,
        height: 260,
        mode: "select",
        searchTimeout: 500,
        title: "Columnas a mostrar..",
        width: 250
      },
      storage: {
        enabled: true,
        type: "localStorage",
        storageKey: "grillaArticulos"
      },
      filterRow: {
        applyFilterText: this.$i18n.t("tabla.applyFilterText"),
        betweenEndText: this.$i18n.t("tabla.betweenEndText"),
        betweenStartText: this.$i18n.t("tabla.betweenStartText"),
        operationDescriptions: {
          between: this.$i18n.t("tabla.between"),
          contains: this.$i18n.t("tabla.contains"),
          endsWith: this.$i18n.t("tabla.endsWith"),
          equal: this.$i18n.t("tabla.equal"),
          greaterThan: this.$i18n.t("tabla.greaterThan"),
          greaterThanOrEqual: this.$i18n.t("tabla.greaterThanOrEqual"),
          lessThan: this.$i18n.t("tabla.lessThan"),
          lessThanOrEqual: this.$i18n.t("tabla.lessThanOrEqual"),
          notContains: this.$i18n.t("tabla.notContains"),
          notEqual: this.$i18n.t("tabla.notEqual"),
          startsWith: this.$i18n.t("tabla.startsWith")
        },
        resetOperationText: this.$i18n.t("tabla.reset"),
        visible: true,
        applyFilter: "auto"
      },
      grouping: {
        allowCollapsing: true,
        contextMenuEnabled: true,
        expandMode: "rowClick",
        texts: {
          groupByThisColumn: this.$i18n.t("tabla.groupByThisColumn"),
          groupContinuedMessage: this.$i18n.t("tabla.groupContinuedMessage"),
          groupContinuesMessage: this.$i18n.t("tabla.groupContinuesMessage"),
          ungroup: this.$i18n.t("tabla.ungroup"),
          ungroupAll: this.$i18n.t("tabla.ungroupAll")
        }
      },
      columnFixing: {
        enabled: true,
        texts: {
          fix: this.$i18n.t("tabla.fix"),
          leftPosition: this.$i18n.t("tabla.leftPosition"),
          rightPosition: this.$i18n.t("tabla.rightPosition"),
          unfix: this.$i18n.t("tabla.unfix")
        }
      },
      remote: { paging: true },
      select: [
        {
          valor: "clasificacion",
          nombre: this.$i18n.t("option.clasificacion")
        },
        {
          valor: "codigo",
          nombre: this.$i18n.t("option.codComp")
        },
        {
          valor: "nro",
          nombre: this.$i18n.t("option.ptoVta")
        },
        {
          valor: "nro_cpr",
          nombre: this.$i18n.t("option.nro")
        },
        {
          valor: "razon_social",
          nombre: this.$i18n.t("option.razon_social")
        },
        {
          valor: "letra",
          nombre: this.$i18n.t("option.letra")
        },
        {
          valor: "tipo_cpr",
          nombre: this.$i18n.t("option.tipo")
        }
      ],
      selectBusqueda: "codigo",
      busqueda: "",
      showDesde: false,
      buttons: [
        {
          icon: "fas fa-info",
          hint: "ver",
          text: "ver",
          cssClass: "buttonInfo",
          onClick: e => {
            this.$router.push({
              name: "previewArticulo",
              params: { _id: e.row.data.bucket_id, lang: this.$i18n.locale }
            });
          }
        }
      ],
      pager: {
        showPageSizeSelector: true,
        showNavigationButtons: true,
        visible: true,
        showInfo: true,
        pageSizes: [5, 20, 50]
      },
      loadPanel: {
        text: this.$i18n.t("modal.loading")
      },
      selection: {
        allowSelectAll: true,
        deferred: false,
        mode: "multiple",
        selectAllMode: "page",
        showCheckBoxesMode: "always"
      },
      paging: {
        pageSize: 100,
        visible: true,
        pageIndex: 0
      }
    };
  },
  methods: {
    realizarBusqueda() {
      this.busqueda = document.getElementById("busqueda").value;
      sessionStorage.setItem("busquedaComp", this.busqueda);
      sessionStorage.setItem("selectBusquedaComp", this.selectBusqueda);
      this.consultaArt();
    },
    consultaArt() {
      var self = this;
      var banderaactivacion = false;
      var banderacamposfechacompletos = false;

      if (self.showDesde) {
        if (self.desde != null && self.hasta != null) {
          banderaactivacion = true;
          banderacamposfechacompletos = true;
        } else {
          notify("Complete los campos fecha desde y hasta", "warning", 3000);
          banderaactivacion = false;
          banderacamposfechacompletos = false;
        }
      } else {
        banderacamposfechacompletos = false;
        banderaactivacion = true;
      }

      if (banderaactivacion) {
        self.dataSource = {
          store: new CustomStore({
            type: "odata",
            key: "cprId",
            load: async function(loadOptions) {
              let params = "?";
              //let filtros = "";

              // loadOptions.take = size;
              // loadOptions.skip = offset;

              // if (loadOptions.take == 'undefined' || loadOptions.take == undefined)
              //   loadOptions.take = limit
              // if (loadOptions.skip == 'undefined' || loadOptions.skip == undefined)
              //   loadOptions.skip = offset
              var request = {
                crossDomain: true,
                headers: {
                  EmpID: sessionStorage.getItem("empId"),
                  Authorization:
                    "Basic " +
                    btoa(
                      sessionStorage.getItem("usuario") +
                        ":" +
                        sessionStorage.getItem("clave")
                    )
                }
              };

              //datos diferidos
              var deferred = $.Deferred();
              params += `&size=${loadOptions.take || 100}`;
              params += `&page=${loadOptions.skip / loadOptions.take || 0}`;

              let campobusqueda = sessionStorage.getItem("selectBusquedaComp");
              let inputbusqueda = self.busqueda;

              if (inputbusqueda && inputbusqueda.trim() != "") {
                params += `&${campobusqueda}=${encodeURIComponent(
                  inputbusqueda
                )}`;
              }

              if (banderacamposfechacompletos) {
                let desde = new Date(self.desde);
                let hasta = new Date(self.hasta);

                desde.setDate(desde.getDate() + 1);
                hasta.setDate(hasta.getDate() + 1);

                params += `&fecha_desde=${desde.toLocaleString()}&fecha_hasta=${hasta.toLocaleString()}`;
              }

              self.metodoBusqueda(self, request, deferred, params);

              //params += `&grupo_id=${encodeURIComponent("ME,AL")}`;
              // params += '&limit=' + loadOptions.take;
              // params += '&offset=' + loadOptions.skip;

              return deferred.promise();
            }
          })
        };
      }
    },
    
    metodoBusqueda(self, request, deferred, params) {
      self.$http
        .get(
          `${self.$store.getters.ws.api_paljet}/cprclientes${params}`,
          request
        )
        .then(async response => {
          if (response.data.name) {
            await self.$nextTick(() => {
              notify(self.$i18n.t("art.resErr"), "warning", 5000);
            });

            deferred.resolve({ data: [], totalCount: 0, totalPages: 0 });
          } else {
            if (response.status == 200) {
              if (response.data._embedded == undefined) {
                notify("Sin Datos", "warning", 3000);
                deferred.resolve({ data: [], totalCount: 0, totalPages: 0 });
              } else {
                await deferred.resolve({
                  data: response.data._embedded.cprClienteResources.map(x => x),
                  totalCount: response.data.page.totalElements,
                  totalPages: response.data.page.totalPages
                });
              }
            } else {
              notify("HUBO UN ERROR", "error", 3000);
              console.log("HUBO UN ERROR");
              //console.log(error);

              deferred.resolve({ data: [], totalCount: 0, totalPages: 0 });
            }
          }
        })
        .catch(() => {
          notify("HUBO UN ERROR", "error", 3000);
          deferred.resolve({ data: [], totalCount: 0, totalPages: 0 });

          //err.response.data.message
        });
    },
    isEmpty(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },
    limpiarFiltro() {
      this.$refs["grillaArticulo"].instance.clearFilter();
    }
  },
  mounted() {
    if (
      sessionStorage.getItem("busquedaComp") !== "" &&
      sessionStorage.getItem("busquedaComp") !== undefined
    ) {
      this.busqueda = sessionStorage.getItem("busquedaComp");
      document.getElementById("busqueda").value = this.busqueda;
      this.selectBusqueda = sessionStorage.getItem("selectBusquedaComp");
      this.consultaArt();
    }
  }
};
</script>
<style>
@import url("../css/w3.css");
.red {
  color: red !important;
}
#articulos {
  margin: 4%;
  margin-top: 0px;
}
.buttonInfo {
  font-size: 20px;
}
.invalid-feedback {
  display: block !important;
}
</style>
